import api from 'api'
import { CACHE_TAG_ACCOUNTING_PERIOD_LOCK } from '../cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    getAccountingPeriodLock: builder.query({
      query: () => ({
        url: '/api/v1/core/accounting-period-lock',
        method: 'GET',
      }),
      providesTags: [CACHE_TAG_ACCOUNTING_PERIOD_LOCK],
    }),
    lockAccountingPeriod: builder.mutation({
      query: body => ({
        url: '/api/v1/core/accounting-period-lock',
        method: 'POST',
        body,
      }),
      invalidatesTags: [CACHE_TAG_ACCOUNTING_PERIOD_LOCK],
    }),
    unlockAccountingPeriod: builder.mutation({
      query: () => ({
        url: '/api/v1/core/accounting-period-lock/unlock',
        method: 'POST',
      }),
      invalidatesTags: [CACHE_TAG_ACCOUNTING_PERIOD_LOCK],
    }),
    getAccountingPeriodLockHistory: builder.query({
      query: () => ({
        url: '/api/v1/core/accounting-period-lock/history',
        method: 'GET',
      }),
      providesTags: [CACHE_TAG_ACCOUNTING_PERIOD_LOCK],
    }),
  }),
})

export const {
  useLazyGetAccountingPeriodLockQuery,
  useLockAccountingPeriodMutation,
  useUnlockAccountingPeriodMutation,
  useLazyGetAccountingPeriodLockHistoryQuery,
} = extendedApi
